export default __webpack_public_path__ + "static/media/czFavicon.1d57ac18.png";